module.exports = " <div class=register_panel _v-c1329e76=\"\"> <form action=\"\" @submit.prevent=submit _v-c1329e76=\"\"> <input-box :content.sync=email input-type=email hint=请输入您的邮箱 _v-c1329e76=\"\"></input-box> <input-box :content.sync=password input-type=password hint=请输入您的密码 _v-c1329e76=\"\"></input-box> <input-box :content.sync=passwordRepeat input-type=password hint=请确认您的密码 _v-c1329e76=\"\"></input-box> <button-box input-type=submit input-value=注册 _v-c1329e76=\"\"></button-box> </form> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-c1329e76!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/RegisterPanel.vue
 ** module id = 364
 ** module chunks = 2
 **/